const styles = {
  MeterChangeDetails: {
    position: 'relative',
    height: { xs: 'calc(100vh - 56px)', sm: 'calc(100vh - 75px)' },
    padding: 2,
    boxSizing: 'border-box',
    backgroundColor: '#f0f0f0',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'auto',
    gap: 2,
  },

  headerRow: {
    display: 'block',
  },

  headerBar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 2,
  },


  fabButton: {
    width: 48,
    height: 48,
    minWidth: 48,
    minHeight: 48,
    borderRadius: '50%',
    backgroundColor: '#5236AB',
    color: '#F0F0F0',
    border: '1px solid #5236AB',
    padding: 0,
    '&:hover': { backgroundColor: '#E0E0E0' },
  },
};

export default styles;
